import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const GoalParametersForm = ({ goalType, parameters, onParametersChange, errors }) => {
  const handleChange = (field, value) => {
    onParametersChange({
      ...parameters,
      [field]: value,
    });
  };

  if (goalType === 'fixed') {
    return (
      <div className="space-y-4">
        <div className="flex items-start space-x-3 p-4 bg-primary/10 rounded-md border border-primary/20">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-foreground mb-1 font-medium">
              고정 횟수 챌린지 설정
            </p>
            <p className="text-xs text-muted-foreground caption">
              목표 횟수만큼 증명을 제출하면 챌린지가 완료됩니다
            </p>
          </div>
        </div>
        <Input
          type="number"
          label="목표 횟수"
          description="총 몇 번의 증명을 제출할 계획인가요?"
          placeholder="예: 10"
          value={parameters?.targetCount || ''}
          onChange={(e) => handleChange('targetCount', e?.target?.value)}
          error={errors?.targetCount}
          required
          min="1"
          max="365"
        />
      </div>
    );
  }

  if (goalType === 'split') {
    return (
      <div className="space-y-4">
        <div className="flex items-start space-x-3 p-4 bg-accent/10 rounded-md border border-accent/20">
          <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-foreground mb-1 font-medium">
              분할 목표 챌린지 설정
            </p>
            <p className="text-xs text-muted-foreground caption">
              큰 목표를 여러 단계로 나누어 점진적으로 달성합니다
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            type="number"
            label="전체 목표 수치"
            description="최종 목표 값"
            placeholder="예: 10"
            value={parameters?.totalGoal || ''}
            onChange={(e) => handleChange('totalGoal', e?.target?.value)}
            error={errors?.totalGoal}
            required
            min="1"
          />

          <Input
            type="number"
            label="분할 단계 수"
            description="몇 단계로 나눌까요?"
            placeholder="예: 10"
            value={parameters?.splitCount || ''}
            onChange={(e) => handleChange('splitCount', e?.target?.value)}
            error={errors?.splitCount}
            required
            min="2"
            max="50"
          />
        </div>
        {parameters?.totalGoal && parameters?.splitCount && (
          <div className="p-4 bg-success/10 rounded-md border border-success/20">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="Calculator" size={18} color="var(--color-success)" />
              <span className="text-sm font-medium text-foreground">
                계산 결과
              </span>
            </div>
            <p className="text-sm text-muted-foreground caption">
              각 단계당{' '}
              <span className="font-semibold text-foreground data-text">
                {(parseFloat(parameters?.totalGoal) / parseFloat(parameters?.splitCount))?.toFixed(2)}
              </span>{' '}
              씩 달성하게 됩니다
            </p>
          </div>
        )}
      </div>
    );
  }

  if (goalType === 'thirty-day') {
    return (
      <div className="space-y-4">
        <div className="flex items-start space-x-3 p-4 bg-success/10 rounded-md border border-success/20">
          <Icon name="Info" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-foreground mb-1 font-medium">
              30일 챌린지 설정
            </p>
            <p className="text-xs text-muted-foreground caption">
              30일 동안 매일 증명을 제출하는 챌린지입니다
            </p>
          </div>
        </div>
        <Input
          type="date"
          label="시작 날짜"
          description="챌린지를 시작할 날짜를 선택하세요"
          value={parameters?.startDate || ''}
          onChange={(e) => handleChange('startDate', e?.target?.value)}
          error={errors?.startDate}
          required
          min={new Date()?.toISOString()?.split('T')?.[0]}
        />
        {parameters?.startDate && (
          <div className="p-4 bg-muted/50 rounded-md">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="Calendar" size={18} color="var(--color-primary)" />
              <span className="text-sm font-medium text-foreground">
                챌린지 기간
              </span>
            </div>
            <p className="text-sm text-muted-foreground caption">
              {parameters?.startDate} 부터{' '}
              {new Date(
                new Date(parameters.startDate).getTime() + 29 * 24 * 60 * 60 * 1000
              )?.toISOString()?.split('T')?.[0]}{' '}
              까지 (30일)
            </p>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default GoalParametersForm;